const Tier = Object.freeze({
  FREE: 'free',
  PREMIUM: 'premium'
});

// --- Free tier limits (keep in sync with backend git.py) ---
export const FREE_TIER_ASSET_LIMIT = 5;
export const FREE_TIER_LIABILITY_LIMIT = 5;
export const FREE_TIER_HISTORY_MONTHS = 3;
// ------------------------------------------------------------------

export default Tier;
